import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDownTimezone = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 6,
	viewBox: "0 0 10 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.47206 0.528514C1.21171 0.268165 0.789596 0.268165 0.529247 0.528514C0.268897 0.788863 0.268897 1.21097 0.529247 1.47132L4.52925 5.47132C4.7896 5.73167 5.21171 5.73167 5.47206 5.47132L9.47206 1.47132C9.73241 1.21097 9.73241 0.788863 9.47206 0.528514C9.21171 0.268165 8.7896 0.268165 8.52925 0.528514L5.00065 4.05711L1.47206 0.528514Z",
		fill: "#232428"
	})]
});
const ForwardRef = forwardRef(SvgArrowDownTimezone);
export { ForwardRef as ReactComponent };
